import { reactive } from 'vue';

import { i18n } from '@libs/i18n';

// todo check later to set globals
declare global {
  interface Window {
    gtmConfig: Record<string, any>[];
  }
}

const { t } = i18n.global;

export type FLOW_STYLES_TYPE = {
  stateName: string;
  stateNameColor: string;
  invisibleStateName: boolean;
  boxStyle: string;
  iconColor: string;
  initialOfferTextColor: string;
  arrowIconColor: string;
  sheetHeight: number;
  targetRoute: string | null;
  description: string | null;
  descriptionColor: string;
  showArrowIcon: boolean;
  offerHasPrice: boolean;
  showDetail: boolean;
  showInformationInDetail: boolean;
  showRequestTime: boolean;
  showDepositButton: boolean;
  showCreateOrderButton: boolean;
  showCancelRequestButton: boolean;
  showSubmitNewRequestButton: boolean;
  isPreOrder: boolean;
};

export const FORM_TYPES = {
  buy: 'buy',
  edit: 'edit',
};

export const IPO_INITIAL_STATES = {
  beforePreOrderEnd: 0,
  betweenEndPreOrderAndStartOrder: 1,
  betweenStartOrderAndEndOrder: 2,
  afterEndOrder: 3,
};

export const IPO_CONFIG_DEFAULT = {
  enabled: false,
  isin: null,
  prefix: null,
  postfix: null,
  description: null,
  link: null,
};

export const IPO_QUERY_KEYS = {
  ipo: ['ipo'],
};

export const IPO_CONFIG = reactive([{ ...IPO_CONFIG_DEFAULT }]);

// This scope manage by Google Tag Manager
Object.defineProperty(window.gtmConfig || {}, 'IPO', {
  set(value) {
    Object.assign(IPO_CONFIG, value);
  },
});

export const SPECIAL_PRICE = 999999;

export const MOBILE_NEXT_PRE_IPO = 'Mobile-Next-PreIPO';

export const BEFORE_END_PRE_ORDER = {
  flow1: {
    stateName: t('ipo.requested'),
    stateNameColor: '',
    invisibleStateName: false,
    boxStyle: '!bg-neutral-tertiary !text-neutral-primary',
    iconColor: 'text-brand-primary',
    initialOfferTextColor: 'text-neutral-tertiary-hover',
    arrowIconColor: 'text-gray',
    sheetHeight: 427,
    targetRoute: null,
    description: null,
    descriptionColor: '',
    showArrowIcon: true,
    offerHasPrice: true,
    showDetail: true,
    showInformationInDetail: false,
    showRequestTime: true,
    showDepositButton: false,
    showCreateOrderButton: false,
    showCancelRequestButton: true,
    showSubmitNewRequestButton: false,
    isPreOrder: true,
  },
  flow2: {
    stateName: t('ipo.insufficientPurchasingPower'),
    stateNameColor: 'text-critical-primary',
    invisibleStateName: true,
    boxStyle: '!bg-neutral-tertiary !text-neutral-primary',
    iconColor: 'text-brand-primary',
    initialOfferTextColor: 'text-neutral-tertiary-hover',
    arrowIconColor: 'text-gray',
    sheetHeight: 427,
    targetRoute: null,
    description: t('ipo.notHaveEnoughPurchasingPower'),
    descriptionColor: 'text-critical-primary',
    showArrowIcon: true,
    offerHasPrice: true,
    showDetail: true,
    showInformationInDetail: false,
    showRequestTime: true,
    showDepositButton: true,
    showCreateOrderButton: false,
    showCancelRequestButton: true,
    showSubmitNewRequestButton: false,
    isPreOrder: true,
  },
  flow3: {
    stateName: t('ipo.requested'),
    stateNameColor: '',
    invisibleStateName: false,
    boxStyle: '!bg-neutral-tertiary !text-neutral-primary',
    iconColor: 'text-brand-primary',
    initialOfferTextColor: 'text-neutral-tertiary-hover',
    arrowIconColor: 'text-gray',
    sheetHeight: 385,
    targetRoute: null,
    description: null,
    descriptionColor: '',
    showArrowIcon: true,
    offerHasPrice: false,
    showDetail: true,
    showInformationInDetail: false,
    showRequestTime: true,
    showDepositButton: false,
    showCreateOrderButton: false,
    showCancelRequestButton: true,
    showSubmitNewRequestButton: false,
    isPreOrder: true,
  },
  flow4: {
    stateName: t('ipo.requested'),
    stateNameColor: '',
    invisibleStateName: false,
    boxStyle: '!bg-neutral-tertiary !text-neutral-primary',
    iconColor: 'text-brand-primary',
    initialOfferTextColor: 'text-neutral-tertiary-hover',
    arrowIconColor: 'text-gray',
    sheetHeight: 316,
    targetRoute: null,
    description: null,
    descriptionColor: '',
    showArrowIcon: true,
    offerHasPrice: true,
    showDetail: true,
    showInformationInDetail: false,
    showRequestTime: false,
    showDepositButton: false,
    showCreateOrderButton: false,
    showCancelRequestButton: false,
    showSubmitNewRequestButton: false,
    isPreOrder: true,
  },
  flow5: {
    stateName: t('ipo.insufficientPurchasingPower'),
    stateNameColor: 'text-critical-primary',
    invisibleStateName: true,
    boxStyle: '!bg-neutral-tertiary !text-neutral-primary',
    iconColor: 'text-brand-primary',
    initialOfferTextColor: 'text-neutral-tertiary-hover',
    arrowIconColor: 'text-gray',
    sheetHeight: 376,
    targetRoute: null,
    description: t('ipo.notHaveEnoughPurchasingPower'),
    descriptionColor: 'text-critical-primary',
    showArrowIcon: true,
    offerHasPrice: true,
    showDetail: true,
    showInformationInDetail: false,
    showRequestTime: false,
    showDepositButton: true,
    showCreateOrderButton: false,
    showCancelRequestButton: false,
    showSubmitNewRequestButton: true,
    isPreOrder: true,
  },
  flow6: {
    stateName: t('ipo.requested'),
    stateNameColor: '',
    invisibleStateName: false,
    boxStyle: '!bg-neutral-tertiary !text-neutral-primary',
    iconColor: 'text-brand-primary',
    initialOfferTextColor: 'text-neutral-tertiary-hover',
    arrowIconColor: 'text-gray',
    sheetHeight: 266,
    targetRoute: null,
    description: null,
    descriptionColor: '',
    showArrowIcon: true,
    offerHasPrice: false,
    showDetail: true,
    showInformationInDetail: false,
    showRequestTime: false,
    showDepositButton: false,
    showCreateOrderButton: false,
    showCancelRequestButton: false,
    showSubmitNewRequestButton: false,
    isPreOrder: true,
  },
  flow7: {
    stateName: t('ipo.buyRequest'),
    stateNameColor: 'text-brand-primary',
    invisibleStateName: false,
    boxStyle: '!bg-neutral-tertiary !text-neutral-quaternary',
    iconColor: '!text-neutral-quaternary',
    initialOfferTextColor: 'text-neutral-quaternary',
    arrowIconColor: 'text-brand-primary',
    sheetHeight: 427,
    targetRoute: 'buyPreOrderScreen',
    description: null,
    showArrowIcon: true,
    offerHasPrice: true,
    showDetail: false,
    showInformationInDetail: false,
    showRequestTime: false,
    showDepositButton: false,
    showCreateOrderButton: false,
    showCancelRequestButton: false,
    showSubmitNewRequestButton: false,
    isPreOrder: true,
  },
  flow8: {
    stateName: t('ipo.buyRequest'),
    stateNameColor: 'text-brand-primary',
    invisibleStateName: false,
    boxStyle: '!bg-neutral-tertiary !text-neutral-quaternary',
    iconColor: '!text-neutral-quaternary',
    initialOfferTextColor: 'text-neutral-quaternary',
    arrowIconColor: 'text-brand-primary',
    sheetHeight: 427,
    targetRoute: 'buyPreOrderScreen',
    description: null,
    showArrowIcon: true,
    offerHasPrice: true,
    showDetail: false,
    showInformationInDetail: false,
    showRequestTime: false,
    showDepositButton: false,
    showCreateOrderButton: false,
    showCancelRequestButton: false,
    showSubmitNewRequestButton: false,
    isPreOrder: true,
  },
};

export const BETWEEN_END_PRE_ORDER_START_ORDER = {
  flow1: {
    stateName: t('modules.order.executed'),
    stateNameColor: '',
    invisibleStateName: false,
    boxStyle: '!bg-neutral-tertiary !text-neutral-primary',
    iconColor: 'text-brand-primary',
    initialOfferTextColor: 'text-neutral-tertiary-hover',
    arrowIconColor: 'text-gray',
    sheetHeight: 427,
    targetRoute: 'orderDetail',
    description: null,
    descriptionColor: '',
    showArrowIcon: true,
    offerHasPrice: true,
    showDetail: false,
    showInformationInDetail: false,
    showRequestTime: false,
    showDepositButton: false,
    showCreateOrderButton: false,
    showCancelRequestButton: false,
    showSubmitNewRequestButton: false,
    isPreOrder: true,
  },
  flow2: {
    stateName: t('ipo.requested'),
    stateNameColor: '',
    invisibleStateName: false,
    boxStyle: '!bg-neutral-tertiary !text-neutral-primary',
    iconColor: 'text-brand-primary',
    initialOfferTextColor: 'text-neutral-tertiary-hover',
    arrowIconColor: 'text-gray',
    sheetHeight: 367,
    targetRoute: null,
    description: null,
    descriptionColor: '',
    showArrowIcon: true,
    offerHasPrice: true,
    showDetail: true,
    showInformationInDetail: false,
    showRequestTime: true,
    showDepositButton: false,
    showCreateOrderButton: false,
    showCancelRequestButton: false,
    showSubmitNewRequestButton: false,
    isPreOrder: true,
  },
  flow3: {
    stateName: t('ipo.insufficientPurchasingPower'),
    stateNameColor: 'text-critical-primary',
    invisibleStateName: true,
    boxStyle: '!bg-neutral-tertiary !text-neutral-primary',
    iconColor: 'text-brand-primary',
    initialOfferTextColor: 'text-neutral-tertiary-hover',
    arrowIconColor: 'text-gray',
    sheetHeight: 427,
    targetRoute: null,
    description: t('ipo.notHaveEnoughPurchasingPower'),
    descriptionColor: 'text-critical-primary',
    showArrowIcon: true,
    offerHasPrice: true,
    showDetail: true,
    showInformationInDetail: false,
    showRequestTime: true,
    showDepositButton: true,
    showCreateOrderButton: false,
    showCancelRequestButton: false,
    showSubmitNewRequestButton: false,
    isPreOrder: true,
  },
  flow4: {
    stateName: t('ipo.requested'),
    stateNameColor: '',
    invisibleStateName: false,
    boxStyle: '!bg-neutral-tertiary !text-neutral-primary',
    iconColor: 'text-brand-primary',
    initialOfferTextColor: 'text-neutral-tertiary-hover',
    arrowIconColor: 'text-gray',
    sheetHeight: 317,
    targetRoute: null,
    description: null,
    descriptionColor: '',
    showArrowIcon: true,
    offerHasPrice: false,
    showDetail: true,
    showInformationInDetail: false,
    showRequestTime: true,
    showDepositButton: false,
    showCreateOrderButton: false,
    showCancelRequestButton: false,
    showSubmitNewRequestButton: false,
    isPreOrder: true,
  },
  flow5: {
    stateName: t('ipo.requested'),
    stateNameColor: '',
    invisibleStateName: false,
    boxStyle: '!bg-neutral-tertiary !text-neutral-primary',
    iconColor: 'text-brand-primary',
    initialOfferTextColor: 'text-neutral-tertiary-hover',
    arrowIconColor: 'text-neutral-secondary-disable',
    sheetHeight: 316,
    targetRoute: null,
    description: null,
    descriptionColor: '',
    showArrowIcon: true,
    offerHasPrice: true,
    showDetail: true,
    showInformationInDetail: false,
    showRequestTime: false,
    showDepositButton: false,
    showCreateOrderButton: false,
    showCancelRequestButton: false,
    showSubmitNewRequestButton: false,
    isPreOrder: true,
  },
  flow6: {
    stateName: t('ipo.insufficientPurchasingPower'),
    stateNameColor: 'text-critical-primary',
    invisibleStateName: true,
    boxStyle: '!bg-neutral-tertiary !text-neutral-primary',
    iconColor: 'text-brand-primary',
    initialOfferTextColor: 'text-neutral-tertiary-hover',
    arrowIconColor: 'text-gray',
    sheetHeight: 376,
    targetRoute: null,
    description: t('ipo.notHaveEnoughPurchasingPower'),
    descriptionColor: 'text-critical-primary',
    showArrowIcon: true,
    offerHasPrice: true,
    showDetail: true,
    showInformationInDetail: false,
    showRequestTime: false,
    showDepositButton: true,
    showCreateOrderButton: false,
    showCancelRequestButton: false,
    showSubmitNewRequestButton: false,
    isPreOrder: true,
  },
  flow7: {
    stateName: t('ipo.requested'),
    stateNameColor: '',
    invisibleStateName: false,
    boxStyle: '!bg-neutral-tertiary !text-neutral-primary',
    iconColor: 'text-brand-primary',
    initialOfferTextColor: 'text-neutral-tertiary-hover',
    arrowIconColor: 'text-neutral-secondary-disable',
    sheetHeight: 266,
    targetRoute: null,
    description: null,
    descriptionColor: '',
    showArrowIcon: true,
    offerHasPrice: false,
    showDetail: true,
    showInformationInDetail: false,
    showRequestTime: false,
    showDepositButton: false,
    showCreateOrderButton: false,
    showCancelRequestButton: false,
    showSubmitNewRequestButton: false,
    isPreOrder: true,
  },
  flow8: {
    stateName: t('ipo.waiting'),
    stateNameColor: '',
    invisibleStateName: true,
    boxStyle: '!bg-neutral-tertiary !text-neutral-primary',
    iconColor: 'text-brand-primary',
    initialOfferTextColor: 'text-neutral-tertiary-hover',
    arrowIconColor: 'text-neutral-secondary-disable',
    sheetHeight: 335,
    targetRoute: null,
    description: t('ipo.waitingToOpenStock'),
    descriptionColor: 'text-gray',
    showArrowIcon: false,
    offerHasPrice: true,
    showDetail: true,
    showInformationInDetail: true,
    showRequestTime: false,
    showDepositButton: false,
    showCreateOrderButton: false,
    showCancelRequestButton: false,
    showSubmitNewRequestButton: false,
    isPreOrder: true,
  },
};

export const BETWEEN_START_ORDER_END_ORDER = {
  flow1: {
    stateName: t('modules.order.executed'),
    stateNameColor: '',
    invisibleStateName: false,
    boxStyle: '!bg-neutral-tertiary !text-neutral-primary',
    iconColor: 'text-brand-primary',
    initialOfferTextColor: 'text-neutral-tertiary-hover',
    arrowIconColor: 'text-gray',
    sheetHeight: 427,
    targetRoute: 'orderDetail',
    description: null,
    descriptionColor: '',
    showArrowIcon: true,
    offerHasPrice: true,
    showDetail: false,
    showInformationInDetail: false,
    showRequestTime: false,
    showDepositButton: false,
    showCreateOrderButton: false,
    showCancelRequestButton: false,
    showSubmitNewRequestButton: false,
    isPreOrder: false,
  },
  flow2: {
    stateName: t('ipo.inQueue'),
    stateNameColor: '',
    invisibleStateName: false,
    boxStyle: '!bg-neutral-tertiary !text-neutral-primary',
    iconColor: 'text-brand-primary',
    initialOfferTextColor: 'text-neutral-tertiary-hover',
    arrowIconColor: 'text-gray',
    sheetHeight: 427,
    targetRoute: 'orderDetail',
    description: null,
    descriptionColor: '',
    showArrowIcon: true,
    offerHasPrice: true,
    showDetail: false,
    showInformationInDetail: false,
    showRequestTime: false,
    showDepositButton: false,
    showCreateOrderButton: false,
    showCancelRequestButton: false,
    showSubmitNewRequestButton: false,
    isPreOrder: false,
  },
  flow3: {
    stateName: t('ipo.requested'),
    stateNameColor: '',
    invisibleStateName: false,
    boxStyle: '!bg-neutral-tertiary !text-neutral-primary',
    iconColor: 'text-brand-primary',
    initialOfferTextColor: 'text-neutral-tertiary-hover',
    arrowIconColor: 'text-gray',
    sheetHeight: 485,
    targetRoute: null,
    description: null,
    descriptionColor: '',
    showArrowIcon: true,
    offerHasPrice: true,
    showDetail: true,
    showInformationInDetail: false,
    showRequestTime: true,
    showDepositButton: false,
    showRepurchaseOrderBox: true,
    showRepurchaseOrderButton: true,
    showCreateOrderButton: false,
    showCancelRequestButton: false,
    showSubmitNewRequestButton: false,
    isPreOrder: false,
  },
  flow4: {
    stateName: t('ipo.requested'),
    stateNameColor: '',
    invisibleStateName: false,
    boxStyle: '!bg-neutral-tertiary !text-neutral-primary',
    iconColor: 'text-brand-primary',
    initialOfferTextColor: 'text-neutral-tertiary-hover',
    arrowIconColor: 'text-gray',
    sheetHeight: 425,
    targetRoute: null,
    description: null,
    descriptionColor: '',
    showArrowIcon: true,
    offerHasPrice: true,
    showDetail: true,
    showInformationInDetail: false,
    showRequestTime: false,
    showDepositButton: false,
    showRepurchaseOrderBox: true,
    showRepurchaseOrderButton: true,
    showCreateOrderButton: false,
    showCancelRequestButton: false,
    showSubmitNewRequestButton: false,
    isPreOrder: false,
  },
  flow5: {
    stateName: t('common.buy'),
    stateNameColor: 'text-brand-primary',
    invisibleStateName: false,
    boxStyle: '!bg-neutral-tertiary !text-neutral-primary',
    iconColor: 'text-neutral-primary',
    initialOfferTextColor: 'text-brand-secondary-hover',
    arrowIconColor: 'text-brand-primary',
    sheetHeight: 427,
    targetRoute: 'buyOrder',
    description: null,
    descriptionColor: '',
    showArrowIcon: true,
    offerHasPrice: true,
    showDetail: false,
    showInformationInDetail: false,
    showRequestTime: false,
    showDepositButton: false,
    showCreateOrderButton: false,
    showCancelRequestButton: false,
    showSubmitNewRequestButton: false,
    isPreOrder: false,
  },
};

export const AFTER_END_ORDER = {
  flow1: {
    stateName: t('modules.order.executed'),
    stateNameColor: '',
    invisibleStateName: false,
    boxStyle: '!bg-neutral-primary !text-neutral-primary',
    iconColor: 'text-brand-primary',
    initialOfferTextColor: 'text-neutral-tertiary-hover',
    arrowIconColor: 'text-gray',
    sheetHeight: 427,
    targetRoute: 'orderDetail',
    description: null,
    showArrowIcon: true,
    offerHasPrice: true,
    showDetail: false,
    showInformationInDetail: false,
    showRequestTime: false,
    showDepositButton: false,
    showCreateOrderButton: false,
    showCancelRequestButton: false,
    showSubmitNewRequestButton: false,
    isPreOrder: false,
  },
  flow2: {
    stateName: t('ipo.inQueue'),
    stateNameColor: '',
    invisibleStateName: false,
    boxStyle: '!bg-neutral-tertiary !text-neutral-primary',
    iconColor: 'text-brand-primary',
    initialOfferTextColor: 'text-neutral-tertiary-hover',
    arrowIconColor: 'text-gray',
    sheetHeight: 427,
    targetRoute: 'orderDetail',
    description: null,
    showArrowIcon: true,
    offerHasPrice: true,
    showDetail: false,
    showInformationInDetail: false,
    showRequestTime: false,
    showDepositButton: false,
    showCreateOrderButton: false,
    showCancelRequestButton: false,
    showSubmitNewRequestButton: false,
    isPreOrder: false,
  },
  flow3: {
    stateName: t('ipo.requested'),
    stateNameColor: '',
    invisibleStateName: true,
    boxStyle: '!bg-neutral-tertiary !text-neutral-primary',
    iconColor: 'text-brand-primary',
    initialOfferTextColor: 'text-neutral-tertiary-hover',
    arrowIconColor: 'text-gray',
    sheetHeight: 457,
    targetRoute: null,
    description: t('ipo.afterEndOrderMessage'),
    descriptionColor: 'text-gray',
    showArrowIcon: true,
    offerHasPrice: true,
    showDetail: true,
    showInformationInDetail: false,
    showRequestTime: true,
    showDepositButton: false,
    showRepurchaseOrderBox: true,
    showRepurchaseOrderButton: false,
    showCreateOrderButton: false,
    showCancelRequestButton: false,
    showSubmitNewRequestButton: false,
    isPreOrder: false,
  },
  flow4: {
    stateName: t('ipo.requested'),
    stateNameColor: '',
    invisibleStateName: true,
    boxStyle: '!bg-neutral-tertiary !text-neutral-primary',
    iconColor: 'text-brand-primary',
    initialOfferTextColor: 'text-neutral-tertiary-hover',
    arrowIconColor: 'text-gray',
    sheetHeight: 407,
    targetRoute: null,
    description: t('ipo.afterEndOrderMessage'),
    descriptionColor: 'text-gray',
    showArrowIcon: true,
    offerHasPrice: true,
    showDetail: true,
    showInformationInDetail: false,
    showRequestTime: false,
    showDepositButton: false,
    showRepurchaseOrderBox: true,
    showRepurchaseOrderButton: false,
    showCreateOrderButton: false,
    showCancelRequestButton: false,
    showSubmitNewRequestButton: false,
    isPreOrder: false,
  },
  flow5: {
    stateName: t('ipo.insufficientPurchasingPower'),
    stateNameColor: 'text-critical-primary',
    invisibleStateName: true,
    boxStyle: '!bg-neutral-tertiary !text-neutral-primary',
    iconColor: 'text-brand-primary',
    initialOfferTextColor: 'text-neutral-tertiary-hover',
    arrowIconColor: 'text-gray',
    sheetHeight: 327,
    targetRoute: null,
    description: t('ipo.afterEndOrderMessage'),
    descriptionColor: 'text-gray',
    showArrowIcon: false,
    offerHasPrice: true,
    showDetail: false,
    showInformationInDetail: false,
    showRequestTime: false,
    showDepositButton: false,
    showCreateOrderButton: false,
    showCancelRequestButton: false,
    showSubmitNewRequestButton: false,
    isPreOrder: false,
  },
};

export const IPO_ORDER_TYPE = {
  preOrder: 'preOrder',
  preOrderNoPrice: 'preOrderNoPrice',
  order: 'order',
} as const;

export const AUTOMATIC_IPO_REQUEST_LINK =
  'https://my.irfarabi.com/customer-club/ipo?utm_source=Helium&utm_medium=On-site&utm_campaign=IPO';
